import { render, staticRenderFns } from "./BaseEventTimer.vue?vue&type=template&id=1fa057ec&scoped=true"
import script from "./BaseEventTimer.vue?vue&type=script&lang=js"
export * from "./BaseEventTimer.vue?vue&type=script&lang=js"
import style0 from "./BaseEventTimer.vue?vue&type=style&index=0&id=1fa057ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa057ec",
  null
  
)

export default component.exports